// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'face-happy';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 9a8.437 8.437 0 1 0 16.874 0A8.437 8.437 0 0 0 .562 9z' />
    <path d='M4.226 10.688a.562.562 0 0 0-.53.75 5.624 5.624 0 0 0 10.609 0 .563.563 0 0 0-.53-.75zm9.644-2.813a1.688 1.688 0 0 0-3.182 0m-3.375 0a1.688 1.688 0 0 0-3.183 0' />
  </g>
);

export const viewBox = '0 0 18 18';
